var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 29,
    viewBox: "0 0 72 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 22.3008L11 18.4414L16 23.2656L21 15.5469L26 19.4062H31L36 10.7227L41 7.82812L46 10.7227L51 1.07422L56 10.7227L61 8.79297L66 3.96875L72 7.82812V28.0898H0V20.3711L6 22.3008Z",
    fill: "url(#paint0_linear_9_2147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 20.3711L6 22.3008L11 18.4414L16 22.3008L21 15.5469L26 19.4062H31L36 10.7227L41 7.82812L46 10.7227L51 1.07422L56 10.7227L61 8.79297L66 3.96875L71 7.82812",
    fill: "url(#paint1_linear_9_2147)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.3711L6 22.3008L11 18.4414L16 22.3008L21 15.5469L26 19.4062H31L36 10.7227L41 7.82812L46 10.7227L51 1.07422L56 10.7227L61 8.79297L66 3.96875L71 7.82812",
    stroke: "#D41216",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2147",
    x1: -15,
    y1: -10.1823,
    x2: -15,
    y2: 28.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_2147",
    x1: -13.5833,
    y1: -7.77018,
    x2: -13.5833,
    y2: 22.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.367de4c43b4951971c16f00bc8d253c5.svg";
export { ForwardRef as ReactComponent };